import React from "react";
import { Nav, NavItem, Button } from "reactstrap";
import ToolbarWrapper from "../../../system/containers/Table/components/Toolbar";
import { checkPermissions } from "../../../system/utils/UserPermissions";

const Toolbar = props => {
  return (
    <ToolbarWrapper>
      <Nav>
        {checkPermissions(props.permissions, ["ALL", "CREATE_PAYMENTS"]) && (
          <NavItem>
            <a href={props.createLink}>
              <Button size="sm" color="success">
                Add New
              </Button>
            </a>
          </NavItem>
        )}
        {checkPermissions(props.permissions, ["ALL", "DELETE_PAYMENTS"]) && (
          <NavItem>
            <Button size="sm" onClick={() => props.handleDelete()}>
              <i className="far fa-trash-alt" /> Delete Selected
            </Button>
          </NavItem>
        )}
        <NavItem className="ml-auto">{props.total} Entries</NavItem>
      </Nav>
    </ToolbarWrapper>
  );
};

export default Toolbar;



// WEBPACK FOOTER //
// ./src/containers/Payments/components/Toolbar.jsx